export default __webpack_public_path__ + "static/moose-d8a32f4d8509e28336787a7220e18d9c.png";